import {
  CHECKOUT_ADD_ON,
  GET_USER_DATA, GET_WALLET, SET_PIN, UPDATE_USER_DATA,
} from '../actionTypes';

const initialState = {
  message: '',
  error: false,
  isLoading: false,
  data: {},
  wallet: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_USER_DATA}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        updatedUser: false,
      };
    case `${GET_USER_DATA}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_USER_DATA}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        data: payload.data.data,
      };

    case `${GET_WALLET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_WALLET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_WALLET}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        wallet: payload.data.data,
      };

    case `${SET_PIN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${SET_PIN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${SET_PIN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        isPinSet: true,
      };

    case `${UPDATE_USER_DATA}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        updatedUser: false,
      };
    case `${UPDATE_USER_DATA}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        updatedUser: false,
      };
    case `${UPDATE_USER_DATA}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        updatedUser: true,
        data: payload.data.data,
      };

    case `${CHECKOUT_ADD_ON}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        updatedUser: false,
      };
    case `${CHECKOUT_ADD_ON}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
        updatedUser: false,
      };
    case `${CHECKOUT_ADD_ON}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
      };

    default:
      return state;
  }
}
